import { cn } from '@/lib/cn'

interface SpinnerProps {
  size?: number
  className?: string
  /** Texto lido por leitores de tela. Passe null quando houver rótulo ao lado. */
  label?: string | null
}

/** Spinner de 8 traços, igual ao usado no componente "Redirecionando…". */
export function Spinner({ size = 20, className, label = 'Carregando' }: SpinnerProps) {
  return (
    <span
      role={label ? 'status' : undefined}
      className={cn('inline-block shrink-0', className)}
      style={{ width: size, height: size }}
    >
      <svg viewBox="0 0 24 24" width={size} height={size} aria-hidden="true">
        {Array.from({ length: 8 }).map((_, index) => (
          <rect
            key={index}
            x="11"
            y="1.5"
            width="2"
            height="6"
            rx="1"
            fill="currentColor"
            opacity={0.15 + index * 0.1}
            transform={`rotate(${index * 45} 12 12)`}
          >
            <animate
              attributeName="opacity"
              values="1;0.15"
              dur="0.8s"
              begin={`${index * 0.1}s`}
              repeatCount="indefinite"
            />
          </rect>
        ))}
      </svg>
      {label && <span className="sr-only">{label}</span>}
    </span>
  )
}
